import { call, put, select, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import { groupChangePasswordActions, createGroupVisitActions, groupForgotPasswordActions, groupVisitActions, groupVisitPasswordActions, groupVisitsActions, groupResetPasswordActions, updateGroupVisitActions } from "./groupVisits.actions";
import { changePasswordApi, createGroupVisitApi, forgotPasswordApi, getGroupVisitApi, getGroupVisitPasswordResetStatusApi, getGroupVisitsApi, resetPasswordApi, updateGroupVisitApi } from "./groupVisits.api";
import { GroupVisitDto } from "./groupVisits.dtos";

function* setGroupVisits(result: GroupVisitDto[], newItems: GroupVisitDto[]) {
    result.forEach(i => {
      let oldItemIndex = newItems.findIndex(s => s.id === i.id);
      if (oldItemIndex === -1) newItems.push(i);
      else newItems[oldItemIndex] = i;
    }); 
    yield put({ type: getType(groupVisitsActions.success), payload: newItems });
    sessionStorage.setItem(`groupVisits`, JSON.stringify(newItems));
}

function* handleGetGroupVisits(request: ReturnType<typeof groupVisitsActions.request>) {
    const groupVisits: GroupVisitDto[] =  yield call(getGroupVisitsApi);
  
    yield put({ type: getType(groupVisitsActions.success), payload: groupVisits });
    sessionStorage.setItem(`groupVisits`, JSON.stringify(groupVisits));
}

function* handleGetGroupVisit(request: ReturnType<typeof groupVisitActions.request>) {
    const storeGroupVisit: GroupVisitDto = yield select(state => state.groupVisits.groupVisit);
    const groupVisit: GroupVisitDto = (storeGroupVisit !== undefined && storeGroupVisit.id !== undefined && storeGroupVisit.id === request.payload) ? storeGroupVisit : yield call(getGroupVisitApi, request.payload);
  
    yield put({ type: getType(groupVisitActions.success), payload: groupVisit });
}

function* handleUpdateGroupVisit(request: ReturnType<typeof updateGroupVisitActions.request>) {
    const storeList = yield select(state => state.groupVisits.list);
    const updatedGroupVisit: GroupVisitDto = yield call(updateGroupVisitApi, request.payload);
  
    yield put({ type: getType(groupVisitActions.success), payload: updatedGroupVisit });
  
    if (storeList !== undefined && storeList.length !== 0)
      yield setGroupVisits([updatedGroupVisit], JSON.parse(JSON.stringify(storeList)) as GroupVisitDto[]);
}
  
function* handleCreateGroupVisit(request: ReturnType<typeof createGroupVisitActions.request>) {
    const storeList = yield select(state => state.groupVisits.list);
    const createdGroupVisit: GroupVisitDto = yield call(createGroupVisitApi, request.payload);
  
    yield put({ type: getType(groupVisitActions.success), payload: createdGroupVisit });
  
    if (storeList !== undefined && storeList.length !== 0)
      yield setGroupVisits([createdGroupVisit], JSON.parse(JSON.stringify(storeList)) as GroupVisitDto[]);
}


function* handleGetGroupVisitPasswordResetRequired(request: ReturnType<typeof groupVisitPasswordActions.request>) {
  const resetRequired: boolean =  yield call(getGroupVisitPasswordResetStatusApi, request.payload);

  yield put({ type: getType(groupVisitPasswordActions.success), payload: resetRequired });
}

export function* watchGetGroupVisitsRequest() {
    try {
      yield takeLatest(getType(groupVisitsActions.request), handleGetGroupVisits);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchGetGroupVisitRequest() {
    try {
      yield takeLatest(getType(groupVisitActions.request), handleGetGroupVisit);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchUpdateGroupVisitRequest() {
    try {
      yield takeLatest(getType(updateGroupVisitActions.request), handleUpdateGroupVisit);
    }
    catch (err) {
      console.log(err);
    }
}
  
export function* watchCreateGroupVisitRequest() {
    try {
      yield takeLatest(getType(createGroupVisitActions.request), handleCreateGroupVisit);
    }
    catch (err) {
      console.log(err);
    }
}


export function* watchGetGroupVisitPasswordResetRequiredRequest() {
  try {
    yield takeLatest(getType(groupVisitPasswordActions.request), handleGetGroupVisitPasswordResetRequired);
  }
  catch (err) {
    console.log(err);
  }
}


function* handleResetPassword(dto: ReturnType<typeof groupResetPasswordActions.request>) {

  try {

    const response: boolean = yield call(resetPasswordApi, dto.payload);

    if (response) {
      yield put({ type: getType(groupResetPasswordActions.success), payload: true });
      setTimeout(() => { window.location.href = `/visit-login/${dto.payload.groupVisitId}`; }, 1500);
    }
    else {
      put({ type: getType(groupResetPasswordActions.failure), payload: "Reset Password Failed" });
    }

  }
  catch (error) {
    put({ type: getType(groupResetPasswordActions.failure), payload: "Reset Password Failed" });
  }

}

export function* watchGroupResetPasswordRequest() {
    yield takeLatest(getType(groupResetPasswordActions.request), handleResetPassword);
}


function* handleChangePassword(dto: ReturnType<typeof groupChangePasswordActions.request>) {

  try {

    const response: boolean = yield call(changePasswordApi, dto.payload);

    if (response) {
      yield put({ type: getType(groupChangePasswordActions.success), payload: true });
      setTimeout(() => { window.location.href = `/visit-login/${dto.payload.groupVisitId}`; }, 1500);
    }
    else {
      put({ type: getType(groupChangePasswordActions.failure), payload: "Change Password Failed" });
    }

  }
  catch (error) {
    put({ type: getType(groupChangePasswordActions.failure), payload: "Change Password Failed" });
  }

}

export function* watchGroupChangePasswordRequest() {
    yield takeLatest(getType(groupChangePasswordActions.request), handleChangePassword);
}


function* handleGroupForgotPassword(dto: ReturnType<typeof groupForgotPasswordActions.request>) {
  console.log('hello?')
  try {
    yield call(forgotPasswordApi, dto.payload);
  } catch (error) {
    console.log(error)
  }
}

export function* watchGroupForgotPasswordRequest() {
  try {
    yield takeLatest(
      getType(groupForgotPasswordActions.request),
      handleGroupForgotPassword
    );
  } catch (err) {
    console.log(err)
  }
}